// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__12Vws","info":"UpdateTermsInfo_info__2QIL0"};